module.exports = __webpack_public_path__ + "sk.619853763f6e9b5c4b3e.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/sk.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/sk.svg
// module chunks = styles